import cn from "classnames";
import { useEffect, useState } from "react";

import { KEYS } from "@/src/const";
import { StrapiComponentType, DeepSkyType } from "@/src/type";

import { ButtonLinkModule } from "../../../component/ButtonLinkModule";

import styles from "./MobileFooter.module.scss";

interface MobileFooterProps {
  elementIdToTriggerFooter: string;
  floorplan: DeepSkyType.AssetType.PropertyInventory.MarketingFloorPlan;
  propertyUnitDetails: StrapiComponentType.Section.PropertyUnitDetails;
}

function MobileFooter({ elementIdToTriggerFooter, propertyUnitDetails }: MobileFooterProps) {
  const [showFooter, setShowFooter] = useState<boolean>(false);

  /**
   * when the bottom of the inquiry intersections the top head
   * show the footer on mobile only
   */
  useEffect(() => {
    function handleScroll() {
      const observer = document.getElementById(elementIdToTriggerFooter);
      const isMobile = window.innerWidth < 1025;
      if (isMobile && (observer?.getBoundingClientRect()?.top ?? 9999) < 60) {
        if (!showFooter) {
          setShowFooter(true);
          const footerPadding = document.getElementById(KEYS.ELEMENT_IDS.FOOTER_PADDING ?? "");
          if (footerPadding) {
            footerPadding.style.height = "120px";
            footerPadding.style.width = "100%";
          }
        }
      } else {
        if (showFooter) {
          setShowFooter(false);
        }
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [showFooter, elementIdToTriggerFooter]);

  return (
    <div className={styles.container}>
      <div className={cn(styles.inner, showFooter ? styles.active : styles.hidden)}>
        {propertyUnitDetails.scheduledTourCta && (
          <ButtonLinkModule
            buttonLink={propertyUnitDetails.scheduledTourCta}
            className={styles.button}
          />
        )}
      </div>
    </div>
  );
}

export default MobileFooter;
